import { render } from "./TemplateSort.vue?vue&type=template&id=0507def2&scoped=true"
import script from "./TemplateSort.vue?vue&type=script&lang=js"
export * from "./TemplateSort.vue?vue&type=script&lang=js"

import "./TemplateSort.vue?vue&type=style&index=0&id=0507def2&lang=scss&scoped=true"

import exportComponent from "/var/www/kl_keepjoy_work/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0507def2"]])

export default __exports__